import { useCallback, useState } from 'react';
import { useTrackIntercomOpened } from '@frameio/plan-management/account-lock/hooks/useTrackIntercomOpened';
import { MenuButton, ToastAlert, useToast } from '@frameio/vapor';
import { IconPerson } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/ContactSupportMenuItem';

TEXT.DEFINE({
  /** Button label */
  label: 'Contact Support',
  /** Warning toast title shown when the in-app support messenger (Intercom) is unavailable */
  intercomDisabled:
    'Intercom is probably disabled in Segment for this environment.',
});

export const ContactSupportMenuItem = () => {
  const { addToast } = useToast();
  const [isSelected, setSelected] = useState(false);
  const trackIntercomOpened = useTrackIntercomOpened();
  const { intercomDisabled } = TEXT;

  const handleClick = useCallback(() => {
    setSelected(true);
    trackIntercomOpened();
    if (!window.Intercom) {
      setSelected(false);
      addToast(
        (close, closeLabel) => (
          <ToastAlert
            closeLabel={closeLabel}
            onRequestClose={close}
            title={intercomDisabled}
            variant="warning"
          />
        ),
        { duration: 4000 }
      );
      return;
    }

    window.Intercom('onShow', () => {
      // jank but without the timeout, there is a race condition where the iframe doesn't exist yet.
      setTimeout(() => {
        const iframe = document.querySelector(
          'iframe[name="intercom-messenger-frame"]'
        );

        if (iframe) {
          iframe.setAttribute('aria-hidden', 'false');
        }
      }, 300);
    });

    window.Intercom('onHide', () => {
      setSelected(false);

      setTimeout(() => {
        const iframe = document.querySelector(
          'iframe[name="intercom-messenger-frame"]'
        );

        if (iframe) {
          iframe.setAttribute('aria-hidden', 'true');
        }

        // focus on the window so our key listeners work
        window.focus();
      }, 16);
    });
  }, [addToast, trackIntercomOpened, intercomDisabled]);

  return (
    <MenuButton
      aria-expanded={isSelected}
      aria-label={TEXT.label}
      iconBefore={<IconPerson />}
      onClick={handleClick}
    >
      {TEXT.label}
    </MenuButton>
  );
};
